import { render, staticRenderFns } from "./DirectCostItem.vue?vue&type=template&id=36e052cc"
import script from "./DirectCostItem.vue?vue&type=script&lang=js"
export * from "./DirectCostItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports